module.exports = __webpack_public_path__ + "static/media/profilemain.07dc99dd.png";